import http from "../http-common";

class RecurringExpenseService {
  create(data) {
    return http.post("/recurring-expenses", data);
  }

  getAll() {
    return http.get("/recurring-expenses");
  }

  get(id) {
    return http.get(`/recurring-expenses/${id}`);
  }

  update(id, data) {
    return http.put(`/recurring-expenses/${id}`, data);
  }

  delete(id) {
    return http.delete(`/recurring-expenses/${id}`);
  }
}

export default new RecurringExpenseService();
